import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getQuotationList = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/quotation/', {
    headers: authHeader(),
    params: {
      //fields: 'id,quotation_no,quotation_date,customer__customer_name,workorder_no,converted_date,status,created_at,created_by__first_name,created_by__last_name,updated_at,updated_by__first_name,updated_by__last_name,converted_date',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getQuotationArchiveList = (page, pagesize, search, ordering, print) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/quotation/?deleted=1', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
      print: print
    },
  });
};

const getViewQuotationById = (id) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/quotation/`, {
    headers: authHeader(),
  });
};

const getQuotationById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/quotation/${id}`, {
    headers: authHeader(),
  });
};
const QuotationByCreateWorkOrder = values => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/workorder/convert-workorder/`, // Ensure the URL is correct
    values, // Pass the values as the request body
    { headers: authHeader() }, // Include headers if necessary
  );
};
const addQuotation = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/quotation/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};
const updateQuotation = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/quotation/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};
const deleteQuotation = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/quotation/${id}/archive/`,
    {},
    { headers: authHeader() }, // Authentication header
  );
};
const unArchiveQuotationRecord = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/quotation/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const quotationService = {
  getQuotationList,
  getQuotationArchiveList,
  getQuotationById,
  getViewQuotationById,
  addQuotation,
  updateQuotation,
  deleteQuotation,
  unArchiveQuotationRecord,
  QuotationByCreateWorkOrder,
};

export default quotationService;
